import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/Modal/Modal'
import Button from 'components/UI/Button/Button'
import Icon from 'components/UI/Icon/Icon'
import {
  CancelButtonWrapper,
  UploaderContainer
} from './UploadModal.styles.js'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Uploader from 'components/Uploader/Uploader'

export default class UploadModal extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    onAfterUpload: PropTypes.func,
    handleNewImageUrl: PropTypes.func
  }

  static defaultProps = {}

  constructor (props) {
    super(props)

    this.onCancel = this.onCancel.bind(this)
    this.onUploadFinish = this.onUploadFinish.bind(this)
  }

  onCancel () {
    this.props.onCancel()
  }

  onUploadFinish (url) {
    if (!url) return
    this.props.handleNewImageUrl(url)
    this.props.onAfterUpload()
  }

  render () {
    const { onCancel, cancelLabel } = this.props

    return (
      <Modal
        isOpen
        delayCloseTimeoutMS={0}
        overlayColor='rgba(0, 0, 0, 0.8)'
        contentLabel='create'
      >
        <CancelButtonWrapper>
          <Button
            bgColor='red'
            label={cancelLabel}
            shadow
            round
            size='large'
            onClick={this.onCancel}
          >
            <Icon name='cross' color={colors.white} size='large' />
          </Button>
        </CancelButtonWrapper>
        <UploaderContainer>
          <Uploader
            api='https://file.nightzookeeper.com/images/upload'
            uploadedImage={this.onUploadFinish}
          />
        </UploaderContainer>
      </Modal>
    )
  }
}
